<div class="container">
  <form [formGroup]="paxFormGroup">
    <div class="row back-navigation-btn">
      <app-navigate-back-btn (buttonClicked)="navigateToOrderOverViewPage()"></app-navigate-back-btn>
    </div>

    <stepper-bar [inputSteps]="stepperBarSteps" [currentStep]="stepperBarStepsEnum.First"></stepper-bar>

    <div class="row">
      <div class="col">
        <div class="h5">{{ 'PASSENGER_CHANGE.HEADERS.EDIT' | translate }}</div>
      </div>
    </div>

    <div class="passenger-change-wrapper" formArrayName="passengers">
      <div role="alert" class="passenger-change-alert alert alert-info mt-2 d-flex" *ngIf="alertMessage$ | async as alertMessage">
        <i class="passenger-change-alert__icon mdi mdi-information pr-2"></i>
        <div class="passenger-change-alert__text" [innerHtml]="alertMessage?.body"></div>
      </div>
      <app-passenger-accordion
        *ngFor="let passenger of paxData; let i = index; trackBy: formTrackBy"
        class="passenger-change__passenger mt-3 row no-gutters no-wrap"
        [passenger]="passenger"
        [group]="passengerArray.controls[i]"
        [index]="i"
        [formGroupName]="i"
        (switchEvent)="switchEventChange($event)"
        (inputUpdateEvent)="inputUpdateEventChange($event)"
      />
    </div>

    <div class="row py-3">
      <div class="col text-left back-navigation-btn">
        <app-navigate-back-btn (buttonClicked)="navigateToOrderOverViewPage()"></app-navigate-back-btn>
      </div>
      <div class="col text-right button-overview">
        <app-navigate-next-btn
          [handleOnClick]="true"
          [buttonClass]="isOverviewPageNavigationButtonDisabled ? 'disabled-button' : ''"
          (click)="navigateToPassengerChangeOverviewPage()"
          class="float-right"
        ></app-navigate-next-btn>
      </div>
    </div>
  </form>
</div>
